import { axiosInstance } from "../utils/axios"

export const contact = (data) => {
    return axiosInstance().post("/inquiry/add-inquiry", data)
}